import {Dimensions} from 'react-native';
import {shouldLandOnPosHub} from './posLayout';
import {getPosPreference} from './posPreferences';

/** Stack route of the POS Hub (phone landing of restaurant mode). */
export const POS_HUB_ROUTE = 'PosHubScreen';

/** Stack route of the quick-receipt sales screen (tablet / classic landing). */
export const POS_SALES_ROUTE = 'HomeScreen';

/**
 * Route the restaurant (POS) mode opens on once the day is open: the POS Hub on
 * phones (unless switched off in Settings), the quick-receipt screen everywhere
 * else. Reads the live window size and the synchronous preference snapshot, so it
 * is safe to call from non-React code (login, place chooser, deep links).
 *
 * @returns {string} A registered POS stack route name.
 */
export const getPosEntryRoute = () => {
    const width = Dimensions?.get?.('window')?.width;

    return shouldLandOnPosHub({
        width,
        layoutMode: getPosPreference('posLayoutMode'),
        startOnHub: getPosPreference('posStartOnHub'),
    }) ? POS_HUB_ROUTE : POS_SALES_ROUTE;
};

export default getPosEntryRoute;
